import { gql } from "apollo-boost";

/* 픽업장소 시작 */
export const ADMIN_DELIVERY_PLACE_LIST_QUERY = gql`
  query AdminDeliveryPlaceList(
    $skip: Int!
    $take: Int
    $keyword: String
    $dayOfWeek: String
    $deliveryStore_id: String
  ) {
    AdminDeliveryPlaceList(
      skip: $skip
      take: $take
      keyword: $keyword
      dayOfWeek: $dayOfWeek
      deliveryStore_id: $deliveryStore_id
    ) {
      deliveryPlaces {
        id
        createdAt
        updatedAt

        name
        managerName
        managerPhone
        zipcode
        roadAddress
        jibunAddress
        addressDetail
        longitude
        latitude
        dayOfWeek

        deliveryStore {
          id
          createdAt
          updatedAt

          store {
            id
            createdAt
            updatedAt

            name
          }
          user {
            id
            createdAt
            updatedAt

            name
          }
        }

        deliveryBoxesCount
      }
      count
    }
  }
`;
export const ADMIN_DELIVERY_PLACE_WRITE_MUTATION = gql`
  mutation AdminDeliveryPlaceWrite(
    $name: String!
    $managerName: String!
    $managerPhone: String!
    $zipcode: String!
    $jibunAddress: String!
    $roadAddress: String!
    $addressDetail: String!
    $longitude: String!
    $latitude: String!
    $dayOfWeek: String!
    $deliveryStore_id: String!
  ) {
    AdminDeliveryPlaceWrite(
      name: $name
      managerName: $managerName
      managerPhone: $managerPhone
      zipcode: $zipcode
      jibunAddress: $jibunAddress
      roadAddress: $roadAddress
      addressDetail: $addressDetail
      longitude: $longitude
      latitude: $latitude
      dayOfWeek: $dayOfWeek
      deliveryStore_id: $deliveryStore_id
    )
  }
`;
export const ADMIN_DELIVERY_PLACE_DETAIL_QUERY = gql`
  query AdminDeliveryPlaceDetail($id: String!) {
    AdminDeliveryPlaceDetail(id: $id) {
      id
      createdAt
      updatedAt

      name
      managerName
      managerPhone
      zipcode
      roadAddress
      jibunAddress
      addressDetail
      longitude
      latitude
      dayOfWeek

      deliveryStore {
        id
        createdAt
        updatedAt

        store {
          id
          createdAt
          updatedAt

          name
        }
        user {
          id
          createdAt
          updatedAt

          name
        }
      }
    }
  }
`;
export const ADMIN_DELIVERY_PLACE_EDIT_MUTATION = gql`
  mutation AdminDeliveryPlaceEdit(
    $id: String!
    $name: String!
    $managerName: String!
    $managerPhone: String!
    $zipcode: String!
    $jibunAddress: String!
    $roadAddress: String!
    $addressDetail: String!
    $longitude: String!
    $latitude: String!
    $dayOfWeek: String!
    $deliveryStore_id: String!
  ) {
    AdminDeliveryPlaceEdit(
      id: $id
      name: $name
      managerName: $managerName
      managerPhone: $managerPhone
      zipcode: $zipcode
      jibunAddress: $jibunAddress
      roadAddress: $roadAddress
      addressDetail: $addressDetail
      longitude: $longitude
      latitude: $latitude
      dayOfWeek: $dayOfWeek
      deliveryStore_id: $deliveryStore_id
    )
  }
`;
export const ADMIN_DELIVERY_STORE_DELETE_MUTATION = gql`
  mutation AdminDeliveryStoreDelete($id: String!) {
    AdminDeliveryStoreDelete(id: $id)
  }
`;
/* 픽업장소 끝 */
